import styled from "styled-components";
import {MainNavCanvasDefaultBox} from "./main-nav-canvas.default.box";

export const MainNavCanvasCasino888Box = styled(MainNavCanvasDefaultBox)`
  background-color: ${({theme}) => theme.colors.backgroundDark};
`